import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context';

export const ProtectedRoute = () => {
  const { user, isLoggedIn } = useAuth();

  if (!isLoggedIn) return <Navigate to="/login" />;

  if (user && !user.phone_verified_at) {
    return <Navigate to="/otp" />;
  }

  return <Outlet />;
};